import { z } from "zod";

import { defaultItem, itemSchema } from "../shared";

// Schema
export const myMindItemSchema = itemSchema.extend({
  label: z.string().min(1),
  description: z.string().default(""),
  percentage: z.number().min(0).max(100).default(0),
  color: z.string().default(""),
});

// Type
export type MyMindItem = z.infer<typeof myMindItemSchema>;

// Defaults
export const defaultMyMindItem: MyMindItem = {
  ...defaultItem,
  label: "",
  description: "",
  percentage: 0,
  color: "",
};
